"use client";

import {Moon, Sun} from "lucide-react";
import {useTheme} from "next-themes";
import {useEffect, useState} from "react";

export function ThemeToggle() {
  const {resolvedTheme, setTheme} = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // We intentionally gate theme-dependent UI until client mount to prevent hydration mismatch.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
  }, []);

  const isDark = resolvedTheme === "dark";
  const buttonTitle = mounted
    ? isDark
      ? "Switch to light mode"
      : "Switch to dark mode"
    : "Toggle theme";

  if (!mounted) {
    return (
      <button
        type="button"
        aria-label="Toggle theme"
        title={buttonTitle}
        className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[var(--clinic-line)] bg-white/50 text-[var(--clinic-ink-soft)] transition hover:border-[#175e52]/40 hover:bg-white dark:border-white/10 dark:bg-white/5 dark:hover:bg-white/10"
      >
        <span className="h-5 w-5" aria-hidden />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => {
        setTheme(isDark ? "light" : "dark");
      }}
      aria-label="Toggle theme"
      title={buttonTitle}
      className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[var(--clinic-line)] bg-white/50 text-[var(--clinic-ink-soft)] transition hover:border-[#175e52]/40 hover:bg-white dark:border-white/10 dark:bg-white/5 dark:hover:bg-white/10"
    >
      {isDark ? (
        <Sun className="h-5 w-5" aria-hidden />
      ) : (
        <Moon className="h-5 w-5" aria-hidden />
      )}
    </button>
  );
}
